module.exports = __webpack_public_path__ + "static/media/jiabanBKCheck2.cd409c2e.png";